import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-circle-solid-info",
  "use": "icon-circle-solid-info-usage",
  "viewBox": "0 0 14 15",
  "content": "<symbol viewBox=\"0 0 14 15\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-circle-solid-info\">\n  <path d=\"M7 .83a6.67 6.67 0 100 13.34A6.67 6.67 0 007 .83zm.67 10H6.33v-4h1.34v4zm0-5.33H6.33V4.17h1.34V5.5z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol